<template>
  <div class="live">
    <div class="nav-content">
      <!-- <div class="live-title">
        style="min-height: 1000px"
        <img src="../assets/imgs/zbt1.png" alt />
        <span>{{$t("message.live")}}</span>
      </div>-->
      <el-radio-group @change="changeSearch" class="dayButton" v-model="data.type">
        <el-radio-button :label="index" v-for="(i,index) in dataList" :key="index">
          <div v-if="i.title.indexOf(' ') > -1">
            <p style="margin-bottom: 5px;">{{i.title.split(' ')[0]}}</p>
            <p>{{i.title.split(' ')[1]}}</p>
          </div>
          <div v-else>
            <p>{{i.title}}</p>
          </div>
        </el-radio-button>
      </el-radio-group>
      <el-radio-group @change="changeData" class="dayButton dataButton" v-model="dataType">
        <el-radio-button :label="index" v-for="(i,index) in tableList" :key="index">
          <div>
            <p>
              <i class="el-icon-date" style="margin-right:4px;"></i>
              {{i.scheDescriptoin}}
            </p>
          </div>
        </el-radio-button>
      </el-radio-group>
      <el-tabs class="dataTab" v-model="activeName" @tab-click="handleClick">
        <!-- <el-tab-pane v-for="(i,index) in nameList" :key="index" :label="i.label" :name="i.name"></el-tab-pane> -->
        <el-tab-pane label="全部" name="first"></el-tab-pane>
        <el-tab-pane label="上午(10:00~12:00)" name="second"></el-tab-pane>
        <el-tab-pane label="下午(15:30~17:00)" name="third"></el-tab-pane>
        <el-tab-pane label="晚上(20:00~21:00)" name="fourth"></el-tab-pane>
      </el-tabs>
      <!-- 1:未开始 2:直播中 3:直播回放 new Date().getFullYear() + '年' +  -->
      <div>
        <YHCard v-if="cardList.length>0" :dataList="cardList" />
        <div class="noData" v-else>暂无数据</div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "../components/Header";
import Footer from "../components/Footer";
import Card from "../components/Card";
import YHCard from "../components/YHCard";
import { callApi } from "../api/callApi";
import { getToken } from "../utils/auth";
import { mapGetters } from "vuex";
import {
  apiMethod,
  pushLog,
  logProdType,
  targetType,
  eventType,
  pageType,
  areaType
} from "../global/config";
export default {
  components: {
    Header,
    Footer,
    Card,
    YHCard
  },
  computed: {
    ...mapGetters({
      activeSchedule: "activeSchedule",
      isWhatSchedule: "isWhatSchedule",
      isWhenSchedule: "isWhenSchedule"
    })
  },
  watch: {
    activeName(newval, oldval) {
      if (newval == "first") {
        this.cardList = this.tableList[this.dataType].myScheduleList;
      } else if (newval == "second") {
        this.cardList = this.tableList[this.dataType].myScheduleListAm;
      } else if (newval == "third") {
        this.cardList = this.tableList[this.dataType].myScheduleListPm;
      } else {
        this.cardList = this.tableList[this.dataType].myScheduleListNight;
      }
    },
    "$i18n.locale"(newval, oldval) {
      this.getvideoForum();
    },
    cardList(newval, oldval) {
      this.$nextTick(() => {
        let toElement = document.getElementById(this.activeSchedule);
        if (this.activeSchedule && toElement) {
          // this.tt = false;
          console.log(this.activeSchedule, toElement);
          document.documentElement.scrollTop =
            this.getElementToPageTop(toElement) - toElement.offsetHeight - 100;
          this.$store.dispatch("setActiveSchedule", "");
        } else {
          window.scrollTo(0, 0);
        }
      });
    }
  },
  data() {
    return {
      // <el-tab-pane label="全部" name="first"></el-tab-pane>
      //   <el-tab-pane label="上午(10:00~12:00)" name="second"></el-tab-pane>
      //   <el-tab-pane label="下午(15:30~17:00)" name="third"></el-tab-pane>
      //   <el-tab-pane label="晚上(20:00~21:00)" name="fourth"></el-tab-pane>
      nameList: [
        {
          lable: "全部",
          name: "first"
        },
        {
          lable: "上午(10:00~12:00)",
          name: "second"
        },
        {
          lable: "下午(15:30~17:00)",
          name: "third"
        },
        {
          lable: "晚上(20:00~21:00)",
          name: "fourth"
        }
      ],
      activeName: "first",
      tt: true,
      dataType: 0,
      cardList: [],
      tableList: [],
      dataList: [],
      myScheduleListHF: "",
      fullWidth: document.documentElement.clientWidth,
      isToday: 0,
      isbefore: 0,
      isafter: 0,
      isShowTabCount: false,
      logo: require("../assets/imgs/shoucang2.png"),
      logoActive: require("../assets/imgs/shoucang (1).png"),
      key: false,
      // activeName: 1,
      show: true,
      data: {
        type: "0",
        eid: localStorage.getItem("eid"), // 会议ID
        timeZone: 0
      },
      myScheduleList: [],
      state: ["观看", "未开始", "直播回放"],
      iconPath: [
        "../assets/imgs/shoucang (1).png",
        "../assets/imgs/shoucang2.png"
      ],
      activeTop: -1,
      eventPosterAddr: "",
      eventPoster: ""
      // collect:true
    };
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab.name, this.activeName);
      // console.log(tab, event);
    },
    playVideo(id, type) {
      if (getToken()) {
        this.$c(this.$g.showScheduleOrMaterial, {
          id: id,
          type: "1"
        }).then(response => {
          if (response.code == 200) {
            if (response.success) {
              this.$c(this.$g.getAssignUser, {
                eid: localStorage.getItem("eid"),
                url:
                  this.$i18n.locale == "zh"
                    ? response.data.path
                    : response.data.pathEn
              }).then(res => {
                if (res.code == 200) {
                  window.open(res.data, "_blank");
                }
              });
              this.Buriedpoint(targetType.AGENDA, id, type);
            } else {
              this.$message({
                message:
                  this.$i18n.locale == "zh"
                    ? response.message.split("/")[0]
                    : response.message.split("/")[1],
                type: "error",
                duration: 3 * 1000
              });
            }
          }
        });
      } else {
        this.$parent.centerDialogVisible = true;
      }
    },
    Buriedpoint(targetType, id, type) {
      console.log("点击");
      pushLog(
        this,
        logProdType.PC,
        pageType.MUDU,
        type == 2 ? eventType.WATCH_LIVE : eventType.Playback,
        targetType,
        id
      );
    },
    getvideoForum() {
      if (this.data.type == "1") {
        callApi(apiMethod.videoForum).then(res => {
          if (res.success) {
            this.eventPosterAddr =
              this.$i18n.locale == "zh"
                ? res.data.eventPosterAddr
                : res.data.eventPosterAddrEn;
            this.eventPoster =
              this.$i18n.locale == "zh"
                ? res.data.eventPoster
                : res.data.eventPosterEn;
          }
        });
      }
    },
    getElementToPageTop(el) {
      if (el.parentElement) {
        return (
          this.getElementToPageTop(el.parentElement.parentElement) +
          el.offsetTop
        );
      }
      return el.offsetTop;
    },
    changeIcon(index, item) {
      //   if(index+1 == item){
      this.show = !this.show;
      //   }
    },
    // 收藏
    // collect () {
    //   this.collect = !this.collect
    //   console.log(this.collect);
    // }
    changeSearch(val) {
      this.tableList = this.dataList[val].list;
      this.cardList = this.tableList[this.dataType].myScheduleList;
      // this.$store.dispatch("setActiveSchedule", "");
      // this.search();
      // if (val == "3") {
      //   callApi(apiMethod.beforeVideoMind).then(res => {
      //     if (res.code == 200 && res.success) {
      //       this.myScheduleListHF = res.data;
      //     }
      //   });
      // }
    },
    changeData(val) {
      this.cardList = this.tableList[val].myScheduleList;
    },
    search(tab, event) {
      callApi(apiMethod.GEt_ONLINE_VIDEO, this.data).then(res => {
        this.myScheduleList = [];
        res.data.map(i => {
          this.myScheduleList.push(i);
        });
      });
      this.getvideoForum();
    },
    async checkToday() {
      await callApi(apiMethod.GEt_TODAY_VIDEO, { timeZone: 0 }).then(res => {
        this.isToday = res.data.today;
        this.isbefore = res.data.before;
        this.isafter = res.data.after;
        if (!this.isToday) {
          if (!this.isafter) {
            this.$set(this.data, "type", "3");
            if (!this.isbefore) {
              this.$set(this.data, "type", "0");
              return true;
            }
            return true;
          }
          this.$set(this.data, "type", "2");
        }
      });
      await this.search();
    },
    addCollect(val) {
      if (getToken()) {
        if (val.followed != "1") {
          this.$c(this.$g.SET_MY_FOLLOW, {
            targetId: val.id,
            targetType: 0
          }).then(response => {
            this.search();
          });
        } else {
          this.$c(this.$g.SET_BACK_MY_FOLLOW, {
            targetId: val.id,
            targetType: 0
          }).then(response => {
            this.search();
          });
        }
      } else {
        this.$refs.header.centerDialogVisible = true;
      }
    },
    handleResize(event) {
      this.fullWidth = document.documentElement.clientWidth;
      console.log(this.fullWidth);
    },
    handleScroll() {
      // console.log(e.target);
      let length = this.cardList.length;
      for (let i = 0; i < length; i++) {
        let id = "cardlist" + i;
        if (
          document.documentElement.scrollTop >
          document.getElementById(id).offsetTop
        ) {
          this.activeTop = i;
        } else if (
          document.documentElement.scrollTop <
          document.getElementById("cardlist0").offsetTop
        ) {
          this.activeTop = -1;
        }
      }
    },
    beforeunloadFn(e) {
      console.log("关闭");
      pushLog(
        this,
        logProdType.PC,
        pageType.LIVE,
        eventType.PAGE_CLOSE,
        targetType.PAGE,
        "/liveroom"
      );
    },
    beforeloadFn(e) {
      console.log("刷新");
      pushLog(
        this,
        logProdType.PC,
        pageType.LIVE,
        eventType.PAGE_LOAD,
        targetType.PAGE,
        "/liveroom"
      );
    },
    getbeforeVideoMind() {
      callApi(apiMethod.beforeVideoMind).then(res => {
        if (res.code == 200 && res.success) {
          this.myScheduleListHF = res.data;
        }
      });
    },
    async getonlineVideoSas() {
      await callApi(apiMethod.onlineVideoSas).then(res => {
        if (res.code == 200 && res.success) {
          this.dataList = res.data;
          this.tableList = this.dataList[0].list;
          this.cardList = this.tableList[0].myScheduleList;
          // this.myScheduleListHF = res.data;
        }
      });
    }
  },

  async created() {
    await this.getonlineVideoSas();
    window.addEventListener("beforeunload", e => this.beforeloadFn(e));
    this.$set(this.data, "type", this.isWhatSchedule);
    this.changeSearch(this.isWhatSchedule);
    this.dataType = this.isWhenSchedule;
    this.changeData(this.isWhenSchedule);
    // window.addEventListener("resize", this.handleResize);
  },
  mounted() {
    // this.beforeloadFn();
    // window.scrollTo(0, 0);
    // this.$ba.trackPageview("/liveroom");
    // window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy: function() {
    // window.removeEventListener("resize", this.handleResize);
    // this.$store.dispatch("setActiveSchedule", "");
    // this.$store.dispatch("setisWhatSchedule", 1);
    // window.removeEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    // window.removeEventListener("scroll", this.handleScroll);
    // window.removeEventListener("beforeunload", e => this.beforeunloadFn(e));
  }
};
</script>
<style lang="less">
.dataTab {
  margin-top: 20px;
.el-tabs__nav-scroll{
  // display: flex;
  // justify-content: center;
}
  .el-tabs__item {
    padding: 0 30px;
  }
  &.el-tabs--top {
    .el-tabs__item.is-top:nth-child(2) {
      padding-left: 50px;
    }
  }
  .el-tabs__active-bar {
    height: 0;
  }
  .el-tabs__nav-wrap::after {
    height: 0;
  }
}
</style>

<style scoped lang="less">
@import "@/style/variable.less";
.noData{
  text-align: center;
  height: 300px;
  line-height: 300px;
}
.activeTop {
  position: fixed;
  top: 100px;
  width: 1080px;
  z-index: 2;
}
.nav-content {
  width: 1080px;
  margin: 0 auto;
  margin-bottom: 40px;
  .cardlist {
    position: relative;
    margin-bottom: 48px;
    // &:nth-child(2) {
    //   margin-top: 0;
    // }

    .card-header {
      // background: url("../assets/imgs/bjtx.png") no-repeat;
      background-size: cover;
      color: rgba(254, 254, 254, 1);
      padding: 15px 0 15px 30px;
      box-sizing: border-box;

      span {
        display: inline-block;
        line-height: 15px;
        font-size: 15px;
      }
    }

    .vedio-ico {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      color: rgba(255, 255, 255, 1);
      font-size: 71px;
      cursor: pointer;
    }

    .video-mes {
      background: rgba(0, 0, 0, 0.6);
      padding: 14px 0 10px 24px;
      position: absolute;
      width: 100%;
      left: 0;
      bottom: 0;
      box-sizing: border-box;
      color: @color-A;
      .card-border-top {
        width: 409px;
        height: 2px;
        background: #2271ff;
        position: absolute;
        top: -2px;
        left: 0;
      }

      .time {
        margin: 10px 0 9px 0;

        img {
          height: 15px;
          width: 15px;
          display: inline-block;
          vertical-align: middle;
          margin-right: 13px;
        }

        span {
          vertical-align: middle;
          font-size: 15px;
          line-height: 15px;
          display: inline-block;
          color: rgba(255, 255, 255, 1);
          font-weight: bold;
        }
      }

      h2 {
        font-size: 23px;
        color: rgba(255, 255, 255, 1);
        // margin-top: 13px;
        line-height: 23px;
      }

      p {
        color: rgba(34, 113, 255, 1);
        font-size: 15px;
        margin-top: 16px;
      }

      .ph {
        color: rgba(255, 255, 255, 1);
        font-weight: 300;
        margin-top: 11px;
      }
    }

    .active {
      &:nth-child(2) {
        .card-border-top {
          display: none;
        }
      }
    }
  }
}

.dayButton {
  width: 100%;
  margin: 20px 0 0 0;
  // display: flex;
  // justify-content: center;
  /deep/.el-radio-button__orig-radio:checked {
    & + .el-radio-button__inner {
      background-color: @color;
      color: #ffffff;
    }
  }
  /deep/ .el-radio-button {
    width: 200px;
    // height: 41px;
    border-radius: 20px;
    font-size: 14x;
    margin-right: 36px;

    .el-radio-button__inner {
      color: #3768a8;
      width: 100%;
      // height: 41px;
      border-radius: 30px;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #85affa;
      padding: 12px 40px;
    }
  }
}
.dataButton {
  /deep/.el-radio-button__orig-radio:checked {
    & + .el-radio-button__inner {
      background-color: @color;
      color: #ffffff;
    }
  }
  /deep/ .el-radio-button {
    width: 200px;
    // height: 41px;
    border-radius: 20px;
    font-size: 14x;
    margin-right: 36px;

    .el-radio-button__inner {
      color: black;
      width: 100%;
      // height: 41px;
      border-radius: 30px;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #85affa;
      padding: 12px 40px;
    }
  }
}
.card {
  border: 1px solid rgba(56, 107, 169, 1);
  border-bottom: none;
  position: relative;
  padding: 15px 30px 15px 30px;
  display: flex;
  background: rgba(255, 255, 255, 1);
  &:last-child {
    border-bottom: 1px solid rgba(56, 107, 169, 1);
  }

  .card-border-top {
    width: 409px;
    height: 2px;
    background: rgba(56, 107, 169, 1);
    position: absolute;
    top: 0;
    left: 0;
  }

  .img-content {
    height: 240px;
    margin-right: 50px;
    flex: 0 0 395px;
  }

  .text-content {
    position: relative;
    flex: 1;

    .time {
      margin: 15px 0 15px 0;

      img {
        height: 20px;
        width: 20px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 13px;
      }

      span {
        vertical-align: middle;
        font-size: 18px;
        line-height: 18px;
        display: inline-block;
        color: @color;
      }
    }

    h2 {
      font-size: 18px;
      color: #222222;
      margin-top: 10px;
      line-height: 30px;
    }

    p {
      color: #626262;
      font-size: 15px;
      margin-top: 15px;
    }

    .ph {
      color: rgba(98, 98, 98, 1);
      // font-weight: 300;
      margin-top: 13px;
    }

    .moreTwo {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    .card-botton {
      margin-top: 29px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: absolute;
      bottom: 0;
      right: 0;
      width: 100%;

      .el-button {
        width: 225px;
        height: 48px;
        background: rgba(34, 113, 255, 1);
        border-radius: 32px;
        font-size: 15px;
        box-shadow: none;
      }

      .collect {
        cursor: pointer;
        margin-right: 22px;

        img {
          display: inline-block;
          vertical-align: middle;
          margin-right: 12px;
        }

        span {
          vertical-align: middle;
          font-size: 15px;
          line-height: 15px;
          display: inline-block;
        }
      }
    }
  }
}

.live {
  margin-top: 20px;
  // background: url("../assets/imgs/bc1@2x.png") no-repeat;
  background-size: 100%;
  position: relative;
  .live-title {
    padding-top: 26px;
    img {
      display: inline-block;
      vertical-align: middle;
      width: 20px;
      height: 21px;
    }
    span {
      font-size: 22px;
      font-weight: bold;
      color: rgba(33, 33, 33, 1);
      margin-left: 15px;
      vertical-align: middle;
    }
  }
  .v-tabs {
    width: 100%;
    height: 100%;
    background-color: red;
    background: url("../assets/imgs/dna1.png") no-repeat;

    .v-tab {
      width: 1080px;
      height: 100%;
      margin: 0 auto;
      margin-top: 93px;
      margin-bottom: 100px;

      .shipin {
        position: relative;
        width: 1280px;
        height: 720px;

        .title {
          width: 1080px;
          height: 90px;
          line-height: 90px;
          background: linear-gradient(
            38deg,
            rgba(34, 113, 255, 1) 0%,
            rgba(246, 249, 254, 1) 100%
          );

          h3 {
            font-size: 30px;
            margin-left: 47px;
          }
        }

        .s-top {
          width: 1080px;
          height: 480px;
          background: #000;
        }

        // 播放icon
        .play {
          width: 85px;
          height: 85px;
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          margin: auto;
          background: url("../assets/imgs/bofang@2x.png") no-repeat;
          background-size: 100%;

          .wrap {
            transform: translateX(-640px) translateY(250px);
            width: 414px;
            height: 3px;
            background: rgba(34, 113, 255, 1);
          }
        }

        .s-bottom {
          width: 1080px;
          height: 250px;
          box-sizing: border-box;
          background-color: #2a4982;

          .desc {
            color: #fff;
            margin-left: 47px;

            h3 {
              padding: 40px 0 28px 0;
              height: 36px;
              line-height: 36px;
              font-size: 36px;
            }

            .time {
              height: 24px;
              line-height: 24px;
              font-size: 24px;
              margin-bottom: 20px;
              background: url("../assets/imgs/shijian1.png") no-repeat;
              background-size: contain;
              padding-left: 30px;
            }

            h5 {
              font-size: 24px;
              margin-bottom: 13px;
              opacity: 0.4;
            }

            .company {
              font-size: 25px;
              padding: 0 5px;
              opacity: 0.4;
            }
          }
        }
      }

      .video-list {
        width: 1080px;
        margin: 180px 0;

        .v-title {
          width: 1280px;
          height: 90px;
          line-height: 90px;
          background: linear-gradient(
            38deg,
            rgba(34, 113, 255, 1) 0%,
            rgba(246, 249, 254, 1) 100%
          );
        }

        .lists {
          width: 1080px;
          color: #212121;

          .list-content {
            width: 1280px;
            height: 440px;
            border: 1px solid #a9c4f2;

            .line {
              width: 491px;
              height: 3px;
              background: rgba(34, 113, 255, 1);
            }

            .shipin {
              width: 1170px;
              height: 332px;
              margin: 52px 0 56px 47px;
              display: flex;
              justify-content: space-between;

              .sleft {
                width: 474px;
                height: 330px;
                border: 1px solid #a9c4f2;

                img {
                  width: 100%;
                  height: 100%;
                }
              }

              .scenter {
                width: 447px;
                margin-left: 59px;

                h3 {
                  margin: 16px 0;
                  font-size: 24px;
                }

                .time {
                  background: url("../assets/imgs/shijian.png") no-repeat;
                  background-size: contain;
                  padding-left: 34px;
                  color: #2271ff;
                  font-size: 20px;
                  line-height: 24px;
                }

                p {
                  margin: 25px 0;
                }

                span {
                  display: block;
                  width: 300px;
                  height: 64px;
                  line-height: 64px;
                  text-align: center;
                  background: rgba(34, 113, 255, 1);
                  border-radius: 32px;
                  color: #fff;
                  margin-top: 81px;
                  cursor: pointer;
                }
              }

              .sright {
                width: 249px;
                height: 330px;
                display: flex;

                .img {
                  width: 20px;
                  height: 20px;
                  margin-top: 294px;

                  img {
                    width: 100%;
                    height: 100%;
                  }
                }

                span {
                  margin-top: 291px;
                  padding-left: 10px;
                  cursor: pointer;
                }
              }
            }
          }
        }
      }
    }

    .bottom {
      .us {
        width: 100%;
        height: 600px;
        position: relative;
        background: url("../assets/imgs/bg6.png") no-repeat;
        background-size: 100%;

        .A-title {
          width: 1200px;
          height: 200px;
          position: absolute;
          left: 50%;
          margin-left: -600px;

          h1 {
            height: 93px;
            padding: 30px 0 0 150px;
            background-size: 128px 93px;
            font-size: 36px;
            color: #2b2b2b;
          }
        }

        .phone {
          width: 1200px;
          height: 192px;
          position: absolute;
          left: 50%;
          margin-left: -600px;
          margin-top: 130px;

          .way {
            margin-left: 150px;
            height: 40px;
            line-height: 40px;
            margin-top: 70px;
            color: #626262;

            h5 {
              font-size: 24px;
            }

            p {
              color: #ccc;
            }
          }

          .code {
            width: 192px;
            height: 192px;
            float: right;
            background: url("../assets/imgs/code.png") no-repeat;
            background-size: 100%;
            margin-right: 50px;
            margin-top: -50px;
          }
        }
      }

      .footer {
        width: 100%;
        height: 200px;
        background-color: #1d66f8;
        position: relative;

        p {
          width: 1200px;
          height: 44px;
          line-height: 44px;
          margin-top: 39px;
          position: absolute;
          left: 50%;
          margin-left: -600px;
          color: #fff;
        }
      }
    }
  }
}
</style>